import React from 'react'
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import Part1 from './part1/Part1'
import Part2 from './part2/Part2'
import Part3 from "./part3/Part3";
import Part4 from "./part4/Part4";
import CorrespondencePanel from "./correspondence/CorrespondencePanel";
import EmailListPanel from "./emailList/EmailListPanel";
import NationalNoticePanel from "./nationalNotice/NationalNoticePanel";

const rp = RouterPath.myProcedure.steps;

function PartsRouter() {
	return (
		<Switch>
			<Route path={rp.MP_1_ID} component={Part1} />
			<Route path={rp.MP_2_ID} component={Part2} />
			<Route path={rp.MP_3_ID} component={Part3} />
			<Route path={rp.MP_4_ID} component={Part4} />
			<Route path={rp.MP_CORRESPONDENCE_ID} component={CorrespondencePanel} />
			<Route path={rp.MP_EMAIL_LIST_ID} component={EmailListPanel} />
			<Route path={rp.MP_NATIONAL_NOTICE_FORM_TYPE_ID} component={NationalNoticePanel} />
		</Switch>
	)
}

PartsRouter.propTypes = {
	classes: PropTypes.any,
}

PartsRouter.defaultProps = {
}

export default PartsRouter;